// extracted by mini-css-extract-plugin
export var container = "_ij-0";
export var segment = "_ij-2";
export var segmentActive = "_ij-3";
export var track = "_ij-1";